// extracted by mini-css-extract-plugin
export default {"container":"VoterOpenPositions_container__qGSZw","header":"VoterOpenPositions_header__O9Mor"};